import React from 'react';

const CategoryWrapper = ({children}) => {
    return (
        <main className="main-wrapper">
            <article itemScope itemType="http://schema.org/Article">
                {children}
            </article>
        </main>
    );
};

export default CategoryWrapper;
